
import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackToHomeButton = () => {
  const navigate = useNavigate();

  return (
    <button 
      onClick={() => navigate('/')} 
      className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
    >
      Back to Home
    </button>
  );
};

export default BackToHomeButton;